import React, { useContext, useState, useEffect } from 'react';
import AppContext from '../../AppContext';
import { TischOffensiveProducts } from './TischOffensiveProducts';
import { SearchProducts } from './SearchProducts';
import { getSearchParam } from '../../utils/getSearchParam';
import {
  SpinnerIcon,
  SpacingBox,
  CenteredWidthLayout,
  GoBackRouteButton,
  Container,
} from '../../Components';
import { getTranslateByScope } from '../../i18n';

const translate = getTranslateByScope('app.productDetail');

const ProductList = (props) => {
  const [page, setPage] = useState(1);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const context = useContext(AppContext);

  const onSearch = (search) => {
    props.history.replace(`/productList?search=${search}`);
    setPage(1);
  };

  const tischOffensiveId = getSearchParam(props, 'tischOffensiveId');
  const defaultSearch = getSearchParam(props, 'search');
  const clusters = getSearchParam(props, 'clusters') || '';
  const genre = getSearchParam(props, 'genre');
  const marketing = !!context.state.marketing;

  let clusterWithGenre = clusters;
  if (genre) {
    clusterWithGenre = clusters;
  }

  useEffect(() => {
    setTimeout(() => {
      setLoadingProducts(false);
    }, 500);
  }, [tischOffensiveId, defaultSearch, clusters]);

  if (loadingProducts) {
    return (
      <CenteredWidthLayout>
        <SpinnerIcon />
      </CenteredWidthLayout>
    );
  }
  if (tischOffensiveId) {
    return (
    <div className="margin-10p">
      <Container>
        <SpacingBox marginTop="lg">
          { !marketing && <GoBackRouteButton text={translate('backToList')} /> }
        </SpacingBox>
      </Container>
      <TischOffensiveProducts
        context={context}
        tischOffensiveId={tischOffensiveId}
      />
    </div>
    );
  }

  return (
    <div className="margin-10p">
      <SearchProducts
        clusters={clusterWithGenre}
        defaultSearch={defaultSearch}
        page={page}
        onSearch={onSearch}
        setPage={setPage}
        tischOffensiveId={tischOffensiveId}
      />
    </div>
  );
};

export default ProductList;
